<template>
  <base-form
    :title="$t('generic.details')"
    :loading="loading"
    @submit="submitForm"
    class="row user-details-edit">
    <div class="d-flex" v-if="user">
      <div class="pr-5">
        <image-upload @on-change="onImageChange"
                      :src="userToEdit.image">
        </image-upload>
      </div>
      <div>
        <base-radio inline v-model="userToEdit.salutation" label="MR">Mr</base-radio>
        <base-radio inline v-model="userToEdit.salutation" label="MISS">Miss</base-radio>
        <br>
        <div class="row">
          <div class="col-12 col-sm-6">
            <fg-input :placeholder="$t('user.details.edit.givenName')"
                      :name="$t('user.details.edit.givenName')"
                      :error="getError($t('user.details.edit.givenName'))"
                      :label="$t('user.details.edit.givenName')"
                      v-validate="modelValidations.given_name"
                      v-model="userToEdit.given_name">
            </fg-input>
          </div>
          <div class="col-12 col-sm-6">
            <fg-input :placeholder="$t('user.details.edit.familyName')"
                      :name="$t('user.details.edit.familyName')"
                      :error="getError($t('user.details.edit.familyName'))"
                      :label="$t('user.details.edit.familyName')"
                      v-validate="modelValidations.family_name"
                      v-model="userToEdit.family_name">
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <section-separator has-border size="lg">
              {{$t('generic.addressAndPhone')}}
            </section-separator>
          </div>
        </div>
        <div class="row"
             v-for="(address, index) in userToEdit.addresses"
             :key="index">
          <div class="col-12">
            <fg-input :placeholder="$t('user.details.edit.address')"
                      :label="$t('user.details.edit.address')"
                      id="city-locality"
                      name="job city"
                      v-model="address.address_line_1"
                      @placechanged="(data, place) => onAddressChange(data, place, index)"
                      addon-left-icon="nc-icon nc-pin-3">
            </fg-input>
          </div>
          <div class="col-12 col-sm-6">
            <fg-input :name="$t('user.details.edit.postal_code')"
                      :error="getError($t('user.details.edit.postal_code'))"
                      :label="$t('user.details.edit.postal_code')"
                      :placeholder="$t('user.details.edit.postal_code')"
                      v-model="address.postal_code">
            </fg-input>
          </div>
          <div class="col-12 col-sm-6">
            <fg-input :name="$t('generic.city')"
                      :placeholder="$t('generic.city')"
                      :label="$t('generic.city')"
                      :error="getError($t('generic.city'))"
                      v-model="address.city">
            </fg-input>
          </div>
          <div class="col-12 col-sm-6">
            <fg-input :label="$t('generic.country')"
                      :error="getError($t('generic.country'))">
              <country-autocomplete v-model="address.country_code"
                                    :name="$t('generic.country')"
                                    :placeholder="$t('generic.country')">
              </country-autocomplete>
            </fg-input>
          </div>
          <div class="col-12"
               v-for="(phone, index) in userToEdit.phones"
               :key="index">
            <fg-input :error="getError($t('user.details.edit.phone'))">
              <phone-input :label="$t('user.details.edit.phone')"
                           @input-data="(data) => onPhoneChange(data, phone)"
                           :name="$t('user.details.edit.phone')"
                           v-model="phone.phone">
              </phone-input>
            </fg-input>
          </div>
        </div>
      </div>
    </div>
  </base-form>
</template>
<script>
  import Vue from 'vue'
  import { mapState, mapActions } from 'vuex'
  import BaseAvatar from 'src/components/BaseAvatar'
  import PhoneInput from 'src/components/PhoneInput'
  import CountryAutocomplete from 'src/components/Autocomplete/CountryAutocomplete'
  import VueGoogleAutocomplete from 'src/components/Autocomplete/VueGoogleAutocomplete'
  import { Select, Option } from 'element-ui'
  import { findCountryCode } from 'src/utils/googleAutocompleteUtils'
  import UserService from 'src/services/UserService'
  import ImageUpload from 'src/components/ImageUpload'
  import config from 'src/config'

  let emptyAddress = {
    label: 'primary',
    postal_code: '',
    city: '',
    country: '',
    country_code: '',
    state_of_province: '',
    address_line_1: '',
    primary: true
  }
  let emptyPhone = {
    country_code: '',
    phone: '',
    primary: true,
    label: 'Default'
  }

  Vue.component(VueGoogleAutocomplete.name, VueGoogleAutocomplete)
  export default {
    name: 'edit-profile-form',
    components: {
      BaseAvatar,
      PhoneInput,
      ImageUpload,
      CountryAutocomplete,
      [Select.name]: Select,
      [Option.name]: Option,
    },

    data () {
      return {
        userToEdit: {},
        loading: false,
      }
    },
    computed: {
      ...mapState('user', {
        user: state => state.user.user
      }),
      modelValidations () {
        return {
          given_name: {
            required: true,
            min: 2
          },
          family_name: {
            required: true,
            min: 2
          },
          phone: {
            phoneNumber: true
          }
        }
      }
    },
    methods: {
      ...mapActions('user', ['refreshProfile']),
      onUserChange (newVal) {
        if (!newVal) return
        this.userToEdit = JSON.parse(JSON.stringify(newVal))
        if (this.userToEdit.addresses && this.userToEdit.addresses.length === 0) {
          this.userToEdit.addresses.push({...emptyAddress})
        }
        if (this.userToEdit.phones && this.userToEdit.phones.length === 0) {
          this.userToEdit.phones.push({...emptyPhone})
        }
      },
      onAddressChange ({postal_code, country, locality, route, street_number, longitude, latitude, administrative_area_level_1}, place, index) {
        let address = this.userToEdit.addresses[index]
        if (postal_code) {
          address.postal_code = postal_code
        }
        if (country) {
          address.country = country
          address.country_code = findCountryCode(place)
        }
        if (locality) {
          address.city = locality
        }
        if (administrative_area_level_1) {
          address.state_of_province = administrative_area_level_1
        }
        if (route) {
          address.address_line_1 = `${route} ${street_number}`
        }
      },
      onImageChange (src) {
        this.userToEdit.image = src
      },
      onPhoneChange ({activeCountry}, phone) {
        if (activeCountry && activeCountry.iso2) {
          phone.country_code = activeCountry.iso2
        }
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      async validate () {
        return this.$validator.validateAll()
      },
      async submitForm () {
        let result = await this.validate()
        if (!result) return
        let data = {
          ...this.userToEdit
        }
        if (data.image.includes('public/v1/avatar')) {
          data.image = null
        }
        try {
          this.loading = true
          await UserService.update(this.userToEdit.uuid, data)
          await this.refreshProfile()
        } finally {
          this.loading = false
        }
      }
    },
    created () {
      this.$watch('user', this.onUserChange, {immediate: true})
    }
  }
</script>
<style lang="scss">
  .user-details-edit {
    .picture-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .all-country-select {
      width: 100%;
      .el-input__prefix {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
</style>
